import React, { useEffect, useState } from "react";
import "./overview/overview.css";
import { Skeleton, Tooltip, Typography, IconButton } from "@mui/material";
import "../Home/home.css";
import "./refund/refund.css";
import "./analytics.css";
import "./analyticsKPI.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";

export default function AnalyticsKPI({
  data,
  showStyling,
  selectedDropdownValue,
  showPercentageKpi,
  isTransactionVolumeFromAnalytics,
  kpiPage,
  singleStartDate,
}) {
  const [shouldHideComparison, setShouldHideComparison] = useState(null);

  useEffect(() => {
    if (selectedDropdownValue === "customDate") {
      if (!singleStartDate) {
        setShouldHideComparison(null);
      } else {
        setShouldHideComparison(singleStartDate);
      }
    } else {
      setShouldHideComparison(null);
    }
  }, [selectedDropdownValue, singleStartDate]);
  let percentage = data?.percent?.toFixed(2);
  let successPercentage =
    Math.floor(data?.successPercent) === data?.successPercent
      ? data?.successPercent?.toString()
      : data?.successPercent?.toFixed(2);
  let contentStylingStyle = { width: "100%" };

  if (data?.title === "Total Payments") {
    contentStylingStyle.backgroundColor = colorBrandObject?.firstKpiColor;
  } else if (data?.title === "Successful Payments") {
    contentStylingStyle.backgroundColor = colorBrandObject?.firstKpiColor;
  } else if (
    data?.title === "Transaction Volume" &&
    !isTransactionVolumeFromAnalytics
  ) {
    contentStylingStyle.backgroundColor = colorBrandObject?.firstKpiColor;
  } else {
    contentStylingStyle.backgroundColor = colorBrandObject?.firstKpiColor;
  }

  if (kpiPage === "payment_link_analytics") {
    contentStylingStyle.backgroundColor = colorBrandObject?.firstKpiColor;
  }

  const toolTipIconAndInfo = (message) => {
    return (
      <Tooltip title={message} arrow sx={{ padding: "0px !important" }}>
        <IconButton
          sx={{
            "&:hover": { backgroundColor: "transparent" },
            padding: "0px !important",
          }}
          disableFocusRipple
          disableTouchRipple
        >
          <InfoOutlinedIcon
            sx={{
              height: "14px",
              width: "14px",
              border: "0px",
              color: "#000000D9",
              padding: "0px !important",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <div className="mainDivOfAnalytics">
      <div className="displayDirectionRow w-100">
        {!data?.title ? (
          <div className="w-100">
            <div className="analytics-kpi-root" style={contentStylingStyle}>
              <Skeleton variant="text" height={25} />
              <Skeleton variant="text" height={25} />
              <Skeleton variant="text" height={25} />
            </div>
          </div>
        ) : (
          <>
            {showPercentageKpi ? (
              <div className="analytics-kpi-root" style={contentStylingStyle}>
                <Typography
                  className="totalPaymentHeading labelSemiBold displayDirectionRow"
                  style={{ gap: "4px", alignItems: "center", color: readableColor(colorBrandObject?.firstKpiColor) }}
                >
                  {data?.title}
                  {data?.tooltipContent &&
                    toolTipIconAndInfo(data?.tooltipContent)}
                </Typography>
                <Typography
                  className="headerH2Bold amountHeading"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                    marginBottom: "4px", color: readableColor(colorBrandObject?.firstKpiColor)
                  }}
                >
                  {data?.valueForLocale}
                  {(data?.title === "Success Rate" ||
                    data?.title === "Conversion Rate" ||
                    data?.title === "Cart Abandonment Rate" ||
                    data?.title === "Success Rate Achieved" ||
                    data?.title === "Transaction Conversion Rate" ||
                    data?.title === "Payment Link Conversion Rate" ||
                    data?.title === "Checkout Conversion Rate" ||
                    data?.title === "Offer Redemption Rate") &&
                    "%"}
                  {!shouldHideComparison && data?.percent !== undefined ? (
                    data?.title !== "Cart Abandonment Rate" &&
                      data?.title !== "Checkout Completion Time" ? (
                      data?.percent !== 0 ? (
                        data?.percent > 0 ? (
                          <img
                            src="/assets/analytics/increase.svg"
                            alt="increase"
                            className="increaseLogo"
                          />
                        ) : (
                          <img
                            src="/assets/analytics/decrease.svg"
                            alt="decrease"
                            className="increaseLogo"
                          />
                        )
                      ) : (
                        <img
                          src="/assets/analytics/grip-lines.svg"
                          alt="same"
                          className="increaseLogo"
                        />
                      )
                    ) : data?.percent !== 0 ? (
                      data?.percent > 0 ? (
                        <img
                          src="/assets/analytics/upperarrownegative.svg"
                          alt="decrease"
                          className="increaseLogo"
                        />
                      ) : (
                        <img
                          src="/assets/analytics/downwardarrownegative.svg"
                          alt="increase"
                          className="increaseLogo"
                        />
                      )
                    ) : (
                      <img
                        src="/assets/analytics/grip-lines.svg"
                        alt="same"
                        className="increaseLogo"
                      />
                    )
                  ) : (
                    ""
                  )}
                </Typography>
                {!shouldHideComparison && data?.percent !== undefined ? (
                  data?.title !== "Cart Abandonment Rate" &&
                    data?.title !== "Checkout Completion Time" ? (
                    <Typography className="labelRegular"
                      style={{ color: "#6c6c6c" }}>
                      {!data?.absoluteDifference && data?.percent !== 0
                        ? Math.abs(percentage) + "%"
                        : ""}
                      {data?.absoluteDifference && data?.successPercent !== 0
                        ? Math.abs(successPercentage) + "%"
                        : ""}
                      {!shouldHideComparison && data?.percent !== undefined
                        ? data?.previousData === false
                          ? "No data to compare"
                          : data?.percent > 0
                            ? " increase from "
                            : data?.percent < 0
                              ? " decrease from "
                              : " No change "
                        : ""}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "yesterday" &&
                        "previous day"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "today" &&
                        "yesterday"}
                      {data?.percent !== 0 &&
                        (selectedDropdownValue == "thisWeek" ||
                          selectedDropdownValue == "lastWeek") &&
                        "last week"}
                      {data?.percent !== 0 &&
                        (selectedDropdownValue == "thisLastMonth" ||
                          selectedDropdownValue == "thisMonth") &&
                        "last month"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "last3Months" &&
                        "last 3 months"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "last6Months" &&
                        "last 6 months"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "last12Months" &&
                        "last 12 months"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "thisYear" &&
                        "last year"}
                    </Typography>
                  ) : (
                    <Typography className="labelRegular" style={{ color: "#6c6c6c" }} >
                      {!data?.absoluteDifference && data?.percent !== 0
                        ? Math.abs(percentage) + "%"
                        : ""}
                      {data?.absoluteDifference && data?.successPercent !== 0
                        ? Math.abs(successPercentage) + "%"
                        : ""}
                      {!shouldHideComparison && data?.percent !== undefined
                        ? data?.previousData === false
                          ? "No data to compare"
                          : data?.percent > 0
                            ? " increase from "
                            : data?.percent < 0
                              ? " decrease from "
                              : " No change from "
                        : ""}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "yesterday" &&
                        "previous day"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "today" &&
                        "yesterday"}
                      {data?.percent !== 0 &&
                        (selectedDropdownValue == "thisWeek" ||
                          selectedDropdownValue == "lastWeek") &&
                        "last week"}
                      {data?.percent !== 0 &&
                        (selectedDropdownValue == "thisLastMonth" ||
                          selectedDropdownValue == "thisMonth") &&
                        "last month"}
                      {data?.percent !== 0 &&
                        selectedDropdownValue == "thisYear" &&
                        "last year"}
                    </Typography>
                  )
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="w-100">
                <div className="analytics-kpi-root" style={contentStylingStyle}>
                  <Typography
                    className="totalPaymentHeading labelSemiBold displayDirectionRow"
                    style={{ gap: "4px", alignItems: "center", color: readableColor(colorBrandObject?.firstKpiColor) }}
                  >
                    {data?.title}
                    {data?.tooltipContent &&
                      toolTipIconAndInfo(data?.tooltipContent)}
                  </Typography>
                  <div style={{ marginTop: "14px" }}>
                    <div
                      className="displayDirectionRow"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography className="bodyB2Regular font-black-high" style={{ color: readableColor(colorBrandObject?.firstKpiColor) }}>
                        Count:
                      </Typography>
                      <Typography
                        className="headerH2Bold countSpace"
                        sx={{ fontSize: "20px !important", color: readableColor(colorBrandObject?.firstKpiColor) }}
                      >
                        {data?.title === "Refund Rate"
                          ? `${data?.countForLocale} %`
                          : data?.countForLocale}
                      </Typography>
                    </div>
                    <div
                      className="displayDirectionRow"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography className="bodyB2Regular font-black-high" style={{ color: readableColor(colorBrandObject?.firstKpiColor) }}>
                        Value:
                      </Typography>
                      <Typography
                        className="headerH2Bold countSpace valueSpace bodyB1color"
                        sx={{ fontSize: "20px !important", color: readableColor(colorBrandObject?.firstKpiColor) }}
                      >
                        {data?.title === "Refund Rate"
                          ? `${data?.value} %`
                          : data?.value}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div >
  );
}
